module.exports = __webpack_public_path__ + "static/img/phone_img.347a955.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/phone_img.png
// module id = kVcd
// module chunks = 1